module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "view__tabs"
  }, [_c('Navigation', {
    attrs: {
      "steps": _vm.form.steps,
      "currentstep": _vm.form.currentstep
    }
  }), _vm._v(" "), (_vm.model.id) ? _c('dropdown', {
    attrs: {
      "label": _vm.actions.label,
      "links": _vm.actions.links,
      "acc": "actions",
      "isNotSync": true
    },
    on: {
      "delete": _vm.deleteCampaign,
      "duplicate": _vm.duplicateCampaign
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "multi-step"
  }, [(_vm.form.currentstep == 1 && !_vm.model.showEditor) ? _c('div', {
    staticClass: "multi-step__step"
  }, [_c('CampaignInformation', {
    ref: "information",
    attrs: {
      "campaign": _vm.model
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.currentstep == 2 && !_vm.model.showEditor) ? _c('div', {
    staticClass: "multi-step__step"
  }, [_c('CampaignTarget', {
    attrs: {
      "campaign": _vm.model
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.currentstep == 3 && !_vm.model.showEditor) ? _c('div', {
    staticClass: "multi-step__step"
  }, [_c('CampaignContent', {
    attrs: {
      "campaign": _vm.model
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.currentstep == 4 && !_vm.model.showEditor) ? _c('div', {
    staticClass: "multi-step__step"
  }, [_c('CampaignPreview', {
    attrs: {
      "campaign": _vm.model
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.currentstep == 5 && !_vm.model.showEditor) ? _c('div', {
    staticClass: "multi-step__step"
  }, [_c('CampaignSuccess', {
    attrs: {
      "campaign": _vm.model
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.form.steps), function(step) {
    return (_vm.form.currentstep != 5) ? _c('Controls', {
      attrs: {
        "step": step,
        "stepcount": _vm.form.steps.length,
        "currentstep": _vm.form.currentstep,
        "nextDisabled": step.nextDisabled || _vm.disableNextButtonForContent
      },
      on: {
        "step-change": _vm.stepChanged
      }
    }) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.model.showEditor) ? _c('div', [_c('bee', {
    attrs: {
      "clientId": _vm.tenant.beeClientId,
      "clientSecret": _vm.tenant.beeClientSecret,
      "layout": _vm.model.template
    },
    on: {
      "onSave": _vm.saveLayout,
      "onAutoSave": _vm.onAutoSave
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4508d35f!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/campaigns/Campaign.vue
// module id = 731
// module chunks = 1